import "formdata-polyfill";

import { fetchMedia } from "./fetchMedia";
import { fetchNews } from "./fetchNews";
import { scroll } from "./scroll";
import { humanDate } from "./humanDate";
import { preview } from "./preview";
import { uniqueList } from "./uniqueList";
import { updateCache } from "./updateCache";
import { notify } from "./notify";
import { request } from "./request";
import { binaryUpload } from "./binaryUpload";
import { trans } from "./trans";
import { buildDamBrowser } from "./buildDamBrowser";
import { playButton } from "./playButton";
import { modal } from "./modal";
// helper imports

import { v4 as uuid } from "uuid";
import he from "he";
// library imports

import { status, languages, lang, urlId, s3bucket, assetHost, assetDomain, placeholder, cachingServiceKeys, months } from "../app";
// constant imports

let damAssets = {
	// on page load, we have no images from DAM
	image: [],
	video: [],
	document: []
};
const allowedImageTypes = ["jpg", "jpeg", "png"];
export const newsButton = $(`<button class="uk-button uk-button-primary" state="create" data-button="create news release">Create news release</button>`);

export const releaseButton = (state, news, tags, updateRouter, author, userLevel, newsButton, newsEditor, buildReleaseEditor) => {
	if (state === "create") {
		newsButton
			.off("click")
			.on("click", function (e) {
				e.preventDefault();
				buildReleaseEditor(news, tags, null, "en", author, userLevel, updateRouter);
			})
			.text("Create news release")
			.attr("state", "create");
	} else {
		newsButton
			.off("click")
			.on("click", function (e) {
				e.preventDefault();
				newsEditor.remove();
				releaseButton("create", news, tags, updateRouter, author, userLevel, newsButton, newsEditor, buildReleaseEditor);
			})
			.text("Cancel news release")
			.attr("state", "cancel");
		// Create/Cancel button click handler
	}
};
// end releaseButton toggle function

const updateSearchTable = (data, lang, context) => {
	return new Promise(async (resolve, reject) => {
		try {
			const release = data.langs[lang];
			const pubDate = new Date(release.pubTime);
			await request(
				{
					reqId: "a5fa2017-5f9c-4858-bd3a-d4c6d81ee7ed",
					data: [
						{
							PutRequest: {
								Item: {
									src: "newsroom",
									id: data.id,
									type: "release",
									pubTime: release.pubTime,
									status: release.status,
									darkpage: release.darkpage ? release.darkpage : false,
									year: pubDate.getFullYear(),
									tags: release.tags,
									text: he.decode(`${release.headline} ${release.newsBody} ${months[pubDate.getMonth()]} ${pubDate.getDate()}, ${pubDate.getFullYear()}`.toLowerCase().replace(/<.+?>/g, "").replace(/\n/g, " "))
								}
							}
						}
					]
				},
				context
			);
			resolve();
		} catch (err) {
			reject(err);
		}
	});
};

export const toggleUpdate = (propEl, news) => {
	// propEl = $("#status_wrapper"), e.g.

	return new Promise(async (resolve, reject) => {
		let id = propEl.parents(".release_wrapper").attr("data-id");
		let spinner = $(`<span class="toggle-spinner" uk-spinner="ratio:.75"></span>`);
		propEl.prepend(spinner);
		propEl.find(".toggle-icon").addClass("pending");
		let _lang = propEl.attr("data-lang");
		let release = news.find(item => item.id === id);
		// release is release matching id

		let attribute = propEl.attr("data-toggle");
		let attrStatus = propEl.attr("data-state") === "false" ? true : false;
		release.langs[_lang][attribute] = attrStatus;
		// attribute named in data-toggle is flipped

		notify("Updating database ... ", "primary", "top-right", 3000, "toggles", "toggles", true);
		try {
			const response = await request(
				{
					reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
					data: [
						{
							PutRequest: {
								Item: release
							}
						}
					]
				},
				$("#news_form")
			);
			if (attribute === "status") {
				notify("Reindexing news database");
				await updateCache(cachingServiceKeys);
				notify("Reindexing complete", "success", "top-right", 3000, null, true);
			}
			notify("Update succeeded", "success", "top-right", 3000, "toggles", "toggles", true);
			propEl.attr("data-state", propEl.attr("data-state") === "false" ? "true" : "false");
			// update property element's attribute value
			let state = propEl.attr("data-state");
			spinner.remove();
			propEl
				.find(".toggle-icon")
				.removeClass("pending")
				.attr("uk-icon", `icon: ${state === "true" ? "check" : "close"}; ratio: 1.2`);
			// remove spinner UI and update icon

			news = news.filter(item => item.id != id && item.lang != _lang);
			news.push(release);
			//  update this release in the news array

			if (attribute === "status" || attribute === "darkpage") {
				// status, darkpage are properties in search table
				// so we need to update there as well
				try {
					await updateSearchTable(release, _lang, propEl);
				} catch (err) {
					console.error(err);
					notify("Error updating search database", "danger");
				}
			}
		} catch (err) {
			spinner.remove();
			propEl.find(".toggle-icon").removeClass("pending");
			// remove loader UI

			console.error(err);
			notify("Error updating release attribute", "danger");
			// cue admin user of issue
		}
	});
};
// end toggleUpdate function

export const buildReleaseEditor = async (news, tags, id = null, editLang = "en", author, userLevel, updateRouter) => {
	let release, editValues;
	let footers = {
		langs: {
			en: "",
			cn: "",
			es: "",
			pt: "",
			ru: ""
		}
	};
	let now = new Date();
	let defaults = {
		created: now.getTime(),
		dateline: "Savannah, Ga.",
		headline: "",
		images: [],
		lang: "en",
		newsBody: "",
		pubTime: now.getTime(),
		featured: true,
		status: false,
		subhead: "",
		summary: "",
		darkpage: false,
		tags: [],
		updated: now.getTime(),
		createdBy: author,
		updatedBy: author
	};
	// let imageArr = {
	//     en: [],
	//     cn: [],
	//     es: [],
	//     pt: [],
	//     ru: [],
	// };

	if (id) {
		release = news.find(item => item.id === id);
		// release now is the release's global values
	} else {
		let values = {};
		for (let key in defaults) {
			values[key] = defaults[key];
		}
		release = {
			langs: {
				[editLang]: Object.assign(values, {
					lang: editLang,
					dateline: trans("Savannah, Ga.", editLang)
				})
			}
		};
	}
	// if new release, this object is just for storing
	// form values between lang changes

	let missing = [];
	Object.keys(languages).forEach(lang => {
		if (!release.langs[lang] || !release.langs[lang].footer) {
			missing.push(lang);
		}
	});
	if (missing.length) {
		updateFooters(missing);
	} else {
		buildNewsEditor(release);
	}
	// are any release lang objects missing the footer
	// property? we should get the stored default footer

	async function updateFooters(missing) {
		try {
			const response = await request({
				reqId: "c6148d32-343e-4918-b0fb-53982f7412e0",
				datatype: "footer",
				keyAdd: "AND #id = :id",
				namesAdd: {
					"#id": "id"
				},
				valuesAdd: {
					":id": "default_footer"
				}
			});
			footers = response[0];
			missing.forEach(lang => {
				if (release.langs[lang]) {
					release.langs[lang].footer = footers.langs[lang];
				}
				// if release lang exists, add default footer;
				// if not, we still have it ready, stored in
				// footer, in case this lang is created
			});
			buildNewsEditor(release);
		} catch (err) {
			console.error("error fetching default footers:", err);
		}
	}
	// get default footers from db

	async function buildNewsEditor(release) {
		if (!release.langs[editLang]) {
			release.langs[editLang] = Object.assign(JSON.parse(JSON.stringify(defaults)), {
				images: release.langs.en && release.langs.en.images ? JSON.parse(JSON.stringify(release.langs.en.images)) : [],
				tags: release.langs.en && release.langs.en.tags ? release.langs.en.tags : [],
				lang: editLang,
				dateline: trans("Savannah, Ga.", editLang),
				footer: footers.langs[editLang]
			});
			if (release.id) {
				id = release.id;
			}
			if (id) {
				release.id = id;
				release.langs[editLang].id = id;
			}
			// editValues now holds this release's lang-based values;
			// if this is the first release for this lang, most values
			// are zeroed out, but images and tags carry over
		}
		editValues = release.langs[editLang];
		if ($("#news_editor").length) {
			$("#news_editor").remove();
		}
		// remove any existing news editor

		["newsBodyEditor", "footerEditor"].forEach(editor => {
			if (tinymce && tinymce.get(editor)) {
				tinymce.get(editor).destroy();
			}
		});
		// destroy tinyMCE editor instances if they exist, so they
		// re-initialize properly downstream

		// imageArr[editLang] = editValues.images && editValues.images.length ? editValues.images : [];
		// update imageArr for this lang version

		let newsEditor = $(`<div id="news_editor" class="bg grey3">
            <div data-wrapper="form wrapper">
                    <form data-lang="${editLang}" class="uk-inline" id="news_form" name="news_form" enctype="multipart/form-data" autocomplete="off"></form>
            </div>
        </div>`);
		// instantiate news editor

		$("#editor_wrapper").append(newsEditor);
		scroll(newsEditor, 200);

		releaseButton("cancel", news, tags, updateRouter, author, userLevel, newsButton, newsEditor, buildReleaseEditor);
		// update news release button

		let pubTime = id ? editValues.pubTime : now.getTime();
		let form = newsEditor.find("#news_form");
		form.append(`
                <div class="uk-flex uk-flex-wrap uk-flex-start">
					<div class="uk-width-1-1 uk-padding-small uk-padding-remove-bottom">
						<p class="italic uk-margin-remove-bottom"><span class="bold">Publishing information:</span><br/>Published by <span class="bold">${editValues.createdBy}</span> on ${humanDate(editValues.created, true, " at ")}.<br/>Last updated by <span class="bold">${editValues.updatedBy}</span> on ${humanDate(editValues.updated, true, " at ")}.<br/><span class="bold">Release ID</span>: ${release.id ? release.id : "Unassigned"}</p>
					</div>
					<div class="separator center ruled uk-width-1-1"></div>
                    <div class="uk-width-1-1 bold uk-padding-small uk-padding-remove-vertical">1. Basic information</div>
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                        <label for="language">Language</label>
                        <select class="caret uk-select" name="lang" value="${editLang}">
                            <option ${editLang === "en" ? "selected" : ""} value="en">English</option>
                            <option ${editLang === "cn" ? "selected" : ""} value="cn">Chinese</option>
                            <option ${editLang === "pt" ? "selected" : ""} value="pt">Portuguese</option>
                            <option ${editLang === "ru" ? "selected" : ""} value="ru">Russian</option>
                            <option ${editLang === "es" ? "selected" : ""} value="es">Spanish</option>
                        </select>
                    </div>
                    <div data-field="tags" class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                        <label for="tags">Tags</label>
                        <select multiple class="caret uk-select" name="tags">
                        </select>
                    </div>
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                        <label for="dateline">Dateline</label>
                        <input class="uk-input" name="dateline" type="text" value="${editValues.dateline ? editValues.dateline : trans("Savannah, Ga.", editLang)}" placeholder="Dateline">
                    </div>
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-expand">
                        <label for="created">Created</label>
                        <input class="uk-input" name="createdReadable" data-timestamp="${editValues.created ? editValues.created : now.getTime()}" type="text" disabled value="${id ? humanDate(editValues.created, true, " at ") : humanDate(now.getTime(), true, " at ")}" placeholder="Date">
                    </div>
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-expand">
                        <label for="pubDate">Publish time</label>
                        <input class="uk-input" type="date" value="${pubTime}" name="pubTime">
                    </div>
                </div>
                <div class="uk-flex uk-flex-wrap uk-flex-start uk-margin-small-top">
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                        <label for="featured">Feature</label>
                        <input class="uk-checkbox" type="checkbox" name="featured" value=${editValues.featured ? editValues.featured : false}> 
                    </div>
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                        <label for="dotcom">Gulfstream.com feed</label>
                        <input class="uk-checkbox" type="checkbox" name="dotcom" value=${editValues.dotcom ? editValues.dotcom : false}> 
                    </div>
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                        <label for="dotcom-sust">Sustainability feed</label>
                        <input class="uk-checkbox" type="checkbox" name="dotcom-sust" value=${editValues["dotcom-sust"] ? editValues["dotcom-sust"] : false}> 
                    </div>
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                        <label for="status">Active</label>
                        <input class="uk-checkbox" name="status" type="checkbox" value=${editValues.status ? editValues.status : false}>
                    </div>
                    <div class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                        <label for="darkpage">Dark Mode item</label>
                        <input class="uk-checkbox" type="checkbox" name="darkpage" value=${editValues.darkpage ? editValues.darkpage : false}> 
                    </div>
                </div>
                <div class="separator center ruled uk-width-1-1"></div>
                <div class="uk-width-1-1 bold uk-padding-small uk-padding-remove-vertical">2. Hero image/video assets</div>
				<div class="uk-padding-small uk-padding-remove-vertical">Use the "expand" button ( <span uk-icon="expand"></span> ) to inspect image. Click the image name to customize it.<br/>The <span class="bold">full-frame preview</span> image shows the image asset with its native cropping. The <span class="bold">thumbnail preview</span> provides an approximate view of the image in thumbnail contexts where auto-cropping might occur. Upload a custom-cropped horizontal thumbnail to better manage framing if auto-cropping on the original image is not acceptable.</div>
                <div class="field uk-padding-small uk-padding-remove-vertical uk-width-auto">
                    <div uk-sortable uk-grid id="image_manager" class="uk-grid uk-grid-small">
                        <label>No images selected</label>
                    </div>
                    <form id="photo-upload-form" enctype="multipart/form-data" class="uk-margin-top">		
		            	<input id="photo-upload-input" class="uk-input uk-width-1-1 uk-width-1-2@s" id="media" name="files[]" accept="image/*" multiple type="file">
						<div class="hidden" id="selected-media"></div>
						<button id="upload_submit" class="uk-button uk-button-primary uk-position-relative" type="button" tabindex="-1">Upload</button>        							
					</form>					
                </div>
				<div class="separator center ruled uk-width-1-1"></div>
                <div class="uk-width-1-1 bold uk-padding-small uk-padding-remove-vertical">3. Content</div>
                <div class="field uk-padding-small uk-padding-remove-vertical uk-width-1-1">
                    <label for="headline">Headline</label>
                    <input class="uk-input" name="headline" type="text" value="${editValues.headline ? editValues.headline : ""}" placeholder="Headline">               
                </div>
                <div class="field uk-padding-small uk-padding-remove-vertical uk-width-1-1">
                    <label for="subhead">Subhead</label>
                    <input class="uk-input" name="subhead" type="text" value="${editValues.subhead ? editValues.subhead : ""}" placeholder="Subhead">
                </div>
                <div class="field uk-padding-small uk-padding-remove-vertical uk-width-1-1">
                    <label for="summary">Summary</label>
                    <textarea class="uk-textarea" rows="2" name="summary" type="text" placeholder="Summary">${editValues.summary ? editValues.summary : ""}</textarea>
                </div>
                <div class="field uk-padding-small uk-padding-remove-vertical uk-width-1-1">
                    <label for="newsBody">Body</label>
                    <textarea name="newsBody" id="newsBodyEditor">${editValues.newsBody ? editValues.newsBody : ""}</textarea>
                </div>
				<div class="field uk-padding-small uk-padding-remove-vertical uk-width-1-1">
					<label>Embed video</p>
					<p class="italic">Option 1: Video from the DAM</p>
					<p>Choose a video from the dropdown. An embed code for it will be copied into your clipboard along with an optional download link. You can then paste the code into the news release by putting the "Body" content editor above into "source code" mode (click the "<>" button in the text editor's menu bar).</p>
					<div uk-grid uk-margin class="field uk-grid-small uk-child-width-1-1 uk-child-width-1-2@s">
						<div>
							<select name="dam_video" id="dam_video">
								<option value="">Select video</option>
							</select>					
						</div>
						<div>
							<p>Include download link? <input type="checkbox" class="uk-checkbox" id="embed_download_link" name="embed_download_link" checked /></p>
						</div>
					</div>
					<p class="italic">Option 2: Other video sources</p>
					If your video source provides an embed code, obtain it, then paste it below over the "Embed code goes here" text. Then copy the entire contents of the text area into your clipboard and paste it into the news release while it is in "source code" mode (click the "<>" button in the content editor menu). <span class="italic">Note that the ability of users to download third-party videos depends on the source.</span></p>
					<textarea id="embedContainer" name="embedContainer" style="height: auto !important; font-family: monospace" class="uk-textarea uk-width-1-1 uk-margin-small-top" rows="3"><div class="news_video_embed">\nEmbed code goes here\n</div></textarea>
					<p><span id="embed_code_copy" class="pointer" uk-icon="copy"></span> Copy embed code</p>
				</div>
                <div class="field uk-padding-small uk-padding-remove-vertical uk-width-1-1">
                    <label for="footer">Footer  [ <span data-button="save default footer" class="underline">Save as default</span> ]</label>
                    <textarea name="footer" id="footerEditor">${editValues.footer ? editValues.footer : footers.langs[editLang]}</textarea>
                </div>
                <div class="separator center ruled uk-width-1-1"></div>
                <div class="uk-width-1-1 bold uk-padding-small uk-padding-remove-vertical">4. Submit</div>
                <div class="field uk-padding-small uk-width-1-1">
                    <div class="form_messaging" id="form_messaging_bottom"></div>
                </div>
                <button class="uk-button uk-button-primary uk-align-left uk-margin-small-left" data-button="submit news form">Submit News Release</button>
                ${id ? `<button class="uk-button uk-button-danger uk-align-right uk-margin-small-right" data-button="delete news release">Delete</button>` : ""}`);
		// instantiates form

		$("select[name='lang']")
			.select2({
				minimumResultsForSearch: Infinity
			})
			.on("change", function () {
				["newsBodyEditor", "footerEditor"].forEach(editor => {
					tinymce.get(editor).save();
				});
				// lang select init; on change,
				// move modified content into textarea inputs

				$("[data-button='approve name change']").trigger("click");
				// close any image name change inputs

				let domImages = $("#image_manager").find(".image_card");
				if (domImages.length) {
					let srcImgs = [].concat(release.langs[editLang].images);
					release.langs[editLang].images = [];
					domImages.each(function (index, domImage) {
						let srcImage = srcImgs.find(item => item.filename === $(domImage).find(".filename").text());
						// let srcImage = imageArr[editLang].find(item => item.filename === $(domImage).find(".filename").text());
						if (srcImage) {
							srcImage.name = $(domImage).find(".image_name").text();
							release.langs[editLang].images.push(srcImage);
						}
					});
				} else {
					release.langs[editLang].images = [];
				}
				form.find("[name]").each(function () {
					let field = $(this).attr("name");
					if (field != "lang") {
						let value = $(this).is("[type='checkbox']") ? $(this).prop("checked") : field === "pubTime" ? $(this).val() * 1000 : $(this).val();
						if (release.langs[editLang]) {
							release.langs[editLang][field] = value;
						} else {
							release.langs[editLang] = {
								[field]: value
							};
						}
					}
					// store current form values, except lang, which just changed
				});
				editLang = $(this).val();
				buildNewsEditor(release);
			});

		// update form if language changes

		$("[data-button='save default footer']").on("click", async function (e) {
			e.preventDefault();
			footers.langs[editLang] = tinymce.get("footerEditor").getContent();
			// place existing value of footer editor into footer object

			notify(`Updating default footer for ${languages[editLang]}...`);
			try {
				const response = await request(
					{
						reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
						data: [
							{
								PutRequest: {
									Item: footers
								}
							}
						]
					},
					$(this).parents(".field").css({ position: "relative" })
				);
				notify("Footer saved", "success");
			} catch (err) {
				console.error("Error saving default footer");
				if (err) {
					console.error(err);
				}
			}
		});
		// edit default footer button click handler

		const manageImages = imageArr => {
			// imageArr is this release lang version's
			// images array

			if (imageArr && imageArr.length) {
				// if (imageArr && imageArr[editLang] && imageArr[editLang].length) {
				let imageMgr = $("#image_manager").html("");
				imageArr.forEach((image, index) => {
					let url = image.location ? image.location : image.url;
					let type = image.type ? image.type.toLowerCase() : "image";
					let name = image.name ? image.name : image.originalname ? image.originalname : image.filename;
					let imgCard = $(`<div data-index="${index}" class="uk-margin-small-right image_card">
                    <div class="image_header dam_card_name metatext">
                        <div class="image_name_wrapper">
                            <span class="bold breakable image_name">${name}</span>
                        </div>
                        <div>
                            <span uk-icon="icon:expand" data-type="${type}" data-button="preview asset"></span>
                            <span data-button="remove image" uk-icon="icon: trash"></span>
                        </div>
                    </div>
					<div uk-grid class="images uk-grid-small uk-child-width-1-1 uk-child-width-1-2@s">
						<div>
							<div>Full-frame preview:</div>
		                    <div class="thumbnail_wrapper">
		                        <img src="${image.thumb ? image.thumb : url}" alt="${name}">
								${type === "video" ? playButton(40) : ""}		                
							</div>
						</div>
						<div>
							<div>Thumbnail preview:</div>
							<div class="thumbnail_preview">							
								<img src="${type === "image" ? (image.customthumb ? image.customthumb : image.thumb ? image.thumb : url) : image.thumb}" alt="${name}">
								${type === "video" ? playButton(40) : ""}
							</div>
							<div class="uk-text-small">${image.customthumb ? "This is a custom upload" : "Auto-crop of source image"}</div>							
							<button data-index="${index}" class="uk-button uk-button-primary uk-button-small uk-align-center uk-margin-small-top uk-margin-small-bottom upload-custom-thumb">Upload custom thumbnail</button>							
						</div>
					</div>
					<div class="dam_card_meta_wrapper">
                        <div class="dam_card_filename"><span class="bold">Filename:</span> <span class="breakable filename">${image.filename}</span></div>
                        <div class="dam_card_source"><span class="bold">Source:</span> <span>${image.src}</span></div>
                        <div class="dam_card_created"><span class="bold">Created:</span> ${humanDate(image.created)}</div>
						<div class="uk-margin-small-top">
							<label>Make downloadable? <input type="checkbox" name="downloadable" class="uk-checkbox"${image.downloadable || !image.hasOwnProperty("downloadable") ? " checked" : ""}></label>
						</div>
                    </div>
                </div>`);
					imageMgr.append(imgCard);
					imgCard.find(".thumbnail_wrapper").on("click", function (e) {
						e.preventDefault();
						if ($(this).parents(".image_card").hasClass("preview")) {
							$(this).parents("#image_manager").find(".image_card").removeClass("preview");
						} else {
							$(this).parents("#image_manager").find(".image_card").removeClass("preview");
							$(this).parents(".image_card").addClass("preview");
						}
						scroll($(".thumbnail_wrapper"), 150);
					});
					// preview button click handler

					imgCard.find(".image_name").on("click", function (e) {
						e.preventDefault();
						let origName = $(this).text().trim();
						let nameWrapper = $(this).parents(".image_name_wrapper");
						$(this).hide();
						nameWrapper.append(`<div class="name_change_wrapper">
                            <input class="uk-input" type="text" name="name_change" value="${name}"/>
                            <span uk-icon="icon: check" data-button="approve name change"></span> <span uk-icon="icon: close" data-button="cancel name change"></span>
                        </div>`);
						nameWrapper.find("[data-button='approve name change']").on("click", function (e) {
							e.preventDefault();
							let newName = nameWrapper.find(".name_change_wrapper input").val().trim();
							// imageArr[editLang][nameWrapper.parents(".image_card").attr("data-index")].name = newName;
							imageArr[nameWrapper.parents(".image_card").attr("data-index")].name = newName;
							// update imageArr (which is a ref to this
							// release lang's images property)

							nameWrapper.find(".image_name").text(newName).show();
							name = newName;
							nameWrapper.find(".name_change_wrapper").remove();
						});
						// approve name change click handler

						nameWrapper.find("[data-button='cancel name change']").on("click", function (e) {
							e.preventDefault();
							nameWrapper.find(".name_change_wrapper").remove();
							nameWrapper.find(".image_name").text(origName).show();
						});

						nameWrapper.find("[name='name_change']").on("focusout", function () {
							$(this).siblings("[data-button='approve name change']").trigger("click");
						});
						// removing focus is same as approving change
					});
					// image name click handler

					imgCard.find(".upload-custom-thumb").on("click", function (e) {
						const imgCard = $(this).parents(".image_card");
						e.preventDefault();
						const uploadModal = modal(`<h3>Upload custom thumbnail</h3>
							<form id="upload-form" enctype="multipart/form-data">		
					            <input id="file" class="uk-input" name="file" type="file">
								<div class="hidden" id="selected-image"></div>
								<button id="thumb-upload-submit" class="uk-button uk-button-primary" type="button" tabindex="-1">Upload</button>        
								<button class="uk-button uk-button-danger uk-modal-close" tabindex="-1">Cancel</button>        
							</form>`);
						$("#thumb-upload-submit").on("click", async function (e) {
							e.preventDefault();
							const submitBtn = $(this);
							const fileInput = submitBtn.siblings("[name='file']");
							const files = fileInput[0].files;
							if (files.length) {
								const keyPrefix = "images/thumbnails";
								for (let i = 0; i < files.length; i++) {
									const data = files[i];
									const formData = new FormData();
									try {
										if (!allowedImageTypes.find(item => data.type.toLowerCase().indexOf(item) > -1)) {
											notify(`${data.name} is not one of ${allowedImageTypes.join(" or ")}`, "danger");
											throw "Image selection error";
										}
										if (files[i].size > 100000) {
											notify(`${data.name} is too large. Thumbnails should be no larger than 100 KBs`, "danger");
											throw "Image selection error";
										}
										const filename = data.name
											.replace(/[\s\+]/g, "-")
											.replace(/%/g, "-percent")
											.replace(/[^-._a-zA-Z0-9]/g, "")
											.replace(/-+/g, "-");
										// Regex: spaces and + signs become "-";
										// "%" becomes "-percent"
										// other non-alphanumeric chars (except "-" and ".") removed;
										// duplicate "-" that result ("--", eg) reduced to single "-"

										const key = `${keyPrefix}/${filename}`;
										const params = {
											reqId: "2273c810-4746-4461-bca7-451c7b8ffecc",
											// formDataUploadToS3Pvt
											env: status,
											bucket: s3bucket,
											key: key,
											storage: "INTELLIGENT_TIERING",
											cacheControl: "public, max-age=300",
											contentType: data.type,
											tagging: `dmSite=Gulfstream News&Project=News Release Custom Thumbnail&Name=${key}`
										};
										for (let prop in params) {
											formData.append(prop, params[prop]);
										}
										formData.append("file", data);
										notify(`Uploading ${filename} ...`);
										const response = await binaryUpload(formData, submitBtn, [], {
											items: [`/${key}`],
											pathCount: 1,
											callerReference: `gulfstreamnews-${new Date().getTime()}`
										});
										if (response.success) {
											const url = `${assetHost}/${key}`;
											imgCard.find(".thumbnail_preview img").attr("src", url);
											const imgIndex = parseInt(imgCard.attr("data-index"));
											imageArr[imgIndex].customthumb = url;
											notify(`Saved "${filename}" to database.`, "success");
											UIkit.modal(uploadModal).hide();
										} else throw response.data;
									} catch (err) {
										console.error(err);
									}
								}
								manageImages(release.langs[editLang].images);
							}
						});
					});
					// custom thumb button click handler

					imgCard.find("[name='downloadable']").on("change", function () {
						imageArr[parseInt($(this).parents(".image_card").attr("data-index"))].downloadable = $(this).prop("checked");
					});
				});

				$("[data-button='preview asset']").on("click", function (e) {
					e.preventDefault();
					let type = $(this).attr("data-type");
					let srcData = imageArr[$(this).parents(".image_card").attr("data-index")];
					// let srcData = imageArr[editLang][$(this).parents(".image_card").attr("data-index")];
					preview(type, srcData);
				});
				// preview asset click handler

				$("[data-button='remove image']").on("click", function (e) {
					e.preventDefault();
					let card = $(this).parents(".image_card");
					imageArr.splice(card.attr("data-index"), 1);
					// imageArr[editLang].splice(card.attr("data-index"), 1);
					// mutate the image array, removing element at this index
					card.remove();
					manageImages(imageArr);
				});
				// remove asset click handler
			}
		};

		/* tag init */
		let tagSelect = $("select[name='tags']");
		let tagSelectOptions = {
			dropdownParent: tagSelect.parents(".field"),
			tags: true, // free-text responses
			tokenSeparators: [","],
			placeholder: "Select tag(s)",
			allowClear: true
		};

		const updateTagSelect = () => {
			tagSelect.html("").css({
				position: "relative"
			});
			let tagsForLang = tags[editLang] ? tags[editLang].sort() : [];
			tagsForLang.forEach(tag => {
				tagSelect.append(`<option ${editValues.tags ? (tag === editValues.tags.find(_tag => _tag === tag) ? "selected" : "") : ""} value="${tag}">${tag}</option>`);
			});
			tagSelect.select2(tagSelectOptions);
		};

		if (Object.keys(tags).length === 0 && tags.constructor === Object) {
			notify(`Fetching current tag set <div uk-spinner></div>`, "primary", "top-left", 3000, "tags");
			try {
				const response = await request(
					{
						reqId: "fcc1be2a-3c7f-464c-b471-21817032c8b2",
						type: "tagList",
						id: "tagList"
					},
					tagSelect
				);
				notify("Tags retrieved", "success", "top-left", 3000, "tags", true);
				tags = Object.assign(tags, response.tags);
				updateTagSelect(tags);
			} catch (err) {
				console.error(err);
				notify("There was an error fetching current tag set", "danger", "top-left", null, "tags");
				tags = { [lang]: [] };
				updateTagSelect(tags);
			}
		} else {
			updateTagSelect();
		}

		const videoSelect = $("select[name='dam_video']");
		let newsVideos;
		try {
			newsVideos = await fetchMedia(
				{
					terms: "nat:video",
					expand: "asset_properties,file_properties,metadata,security,thumbnails,embeds"
				},
				[],
				true
			);
			newsVideos = newsVideos.sort((a, b) => {
				const aVal = lang === "en" ? a.metadata.fields.newsroomDisplayName[0] : a.metadata.fields[`newsroomDisplayName${lang.toUpperCase()}`].length ? a.metadata.fields[`newsroomDisplayName${lang.toUpperCase()}`][0] : a.metadata.fields.newsroomDisplayName[0];
				const bVal = lang === "en" ? b.metadata.fields.newsroomDisplayName[0] : b.metadata.fields[`newsroomDisplayName${lang.toUpperCase()}`].length ? b.metadata.fields[`newsroomDisplayName${lang.toUpperCase()}`][0] : b.metadata.fields.newsroomDisplayName[0];
				return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
			});
			if (newsVideos.length) {
				videoSelect
					.append(
						newsVideos
							.map(video => {
								let vidName = lang === "en" ? video.metadata.fields.newsroomDisplayName[0] : video.metadata.fields[`newsroomDisplayName${lang.toUpperCase()}`].length ? video.metadata.fields[`newsroomDisplayName${lang.toUpperCase()}`][0] : video.metadata.fields.newsroomDisplayName[0];
								return `<option value="${video.id}">${vidName}</option>`;
							})
							.join("")
					)
					.select2({
						minimumResultsForSearch: Infinity,
						placeholder: "Select video"
					})
					.on("change", function () {
						if ($(this).val()) {
							const video = newsVideos.find(item => item.id === $(this).val());
							const downloadable = $("[name='embed_download_link']").prop("checked");
							const embed = downloadable ? (video.embeds.video_player_with_download ? video.embeds.video_player_with_download.html : video.embeds.VideoWithPlayerAndDownload ? video.embeds.VideoWithPlayerAndDownload.html : video.embeds.video_player ? video.embeds.video_player.html : "Video embed not available") : video.embeds.video_player ? video.embeds.video_player.html : "Video embed not available";
							if (video) {
								let vidName = lang === "en" ? video.metadata.fields.newsroomDisplayName[0] : video.metadata.fields[`newsroomDisplayName${lang.toUpperCase()}`].length ? video.metadata.fields[`newsroomDisplayName${lang.toUpperCase()}`][0] : video.metadata.fields.newsroomDisplayName[0];

								navigator.clipboard.writeText(`<div class="news_video_embed">${embed}${downloadable ? (video.embeds.video_player_with_download || video.embeds.VideoWithPlayerAndDownload ? `<div class="download_link"><a href="https://gulfstream.widen.net/download/gulfstream/${video.external_id}/${video.filename}?u=ozllfz">${trans("Download")}</a></div>` : "") : ""}</div>`);
								notify(`Embed code for <strong>${vidName}</strong> copied to clipboard`);
							}
						}
					});
			}
		} catch (err) {
			console.error("Error fetching news release videos:", err);
			notify(`There was an error fetching video data: ${JSON.stringify(err)}`);
		}
		// initialize and populate video select picker

		$("#embed_code_copy").on("click", function () {
			navigator.clipboard.writeText($("#embedContainer").val());
			notify(`Embed code copied to clipboard`);
		});
		// embed code copy button click handler

		$(".flatpickr-calendar").remove();
		// get rid of any existing flatpickr calendars hanging around

		flatpickr("[name='pubTime']", {
			altInput: true,
			altFormat: "F j, Y at h:iK",
			dateFormat: "U",
			defaultDate: id ? pubTime : now.getTime(),
			enableTime: true
		});

		$(".asset_browser_toggle").on("click", async function (e) {
			e.preventDefault();
			let imageArr = release.langs[editLang].images;
			// imageArr is now this release lang
			// version's images array

			let browserToggle = $(this);
			let browser = browserToggle.siblings(".asset_browser");
			if (browserToggle.hasClass("open")) {
				// dam browser is in open state and
				// needs to be closed

				browserToggle.removeClass("open");
				browserToggle.find("[uk-icon]").attr("uk-icon", "icon:chevron-right");
				browser.hide();
			} else {
				// dam browser is closed and
				// needs to be opened, and
				// populated if empty

				browser.show();
				browserToggle.addClass("open");
				browserToggle.find("[uk-icon]").attr("uk-icon", "icon:chevron-down");
				if (!browser.find(".asset_fields_wrapper div").length) {
					// browser has no content

					let type = browserToggle.attr("data-type");
					const onSelect = (input, type, _asset) => {
						if (input.prop("checked")) {
							// selected

							if (_asset.type && _asset.type.toLowerCase() === "video") {
								delete _asset.cart_thumb;
								delete _asset.locator;
								_asset.preview = _asset.thumb ? _asset.thumb : _asset.url;
								try {
									_asset.created = new Date(_asset.created).getTime();
								} catch (err) {
									console.error("could not convert _asset.created to Epoch ms:", _asset.created);
								}
							}
							// clean up videos a little

							imageArr.push(_asset);
							// image array now has this asset

							browserToggle.trigger("click");
							// close DAM browser

							scroll($("#image_manager"));
						} else {
							// deselected
							imageArr = imageArr.filter(item => item.url != _asset.url);
							// imageArr is now imageArr minus this image
						}
						manageImages(imageArr);
					};
					try {
						const response = await fetchMedia(
							{
								terms: type === "image" ? "nat:(image or video)" : type === "video" ? "nat:video" : type === "document" ? "nat:pdf" : "",
								expand: "asset_properties,file_properties,metadata,security,thumbnails,embeds"
							},
							damAssets[type],
							true,
							$("#dam_image_browser")
						);
						damAssets[type] = damAssets[type].concat(response);
						// add assets from this call to assets array

						buildDamBrowser(damAssets[type], browserToggle, onSelect);
					} catch (err) {
						console.error("fetchMedia error:", err);
						notify(err, "danger");
					}
				}
				// end browser is empty
			}
			// end browser is closed
		});
		// asset browser toggle click handler

		$("#upload_submit")
			.off("click")
			.on("click", async function (e) {
				e.preventDefault();
				const submitBtn = $(this);
				const fileInput = submitBtn.siblings("[name='files[]']");
				const files = fileInput[0].files;
				if (files.length) {
					const keyPrefix = "images";
					for (let i = 0; i < files.length; i++) {
						const data = files[i];
						const formData = new FormData();
						try {
							if (!allowedImageTypes.find(item => data.type.toLowerCase().indexOf(item) > -1)) {
								notify(`${data.name} is not one of ${allowedImageTypes.join(" or ")}`, "danger");
								throw "Image selection error";
							}
							if (files[i].size > 4600000) {
								notify(`${data.name} must not be larger than 4.6 MBs`, "danger");
								throw "Image selection error";
							}
							const filename = data.name
								.replace(/[\s\+]/g, "-")
								.replace(/%/g, "-percent")
								.replace(/[^-._a-zA-Z0-9]/g, "")
								.replace(/-+/g, "-");
							// Regex: spaces and + signs become "-";
							// "%" becomes "-percent"
							// other non-alphanumeric chars (except "-" and ".") removed;
							// duplicate "-" that result ("--", eg) reduced to single "-"

							const key = `${keyPrefix}/${filename}`;
							const params = {
								reqId: "2273c810-4746-4461-bca7-451c7b8ffecc",
								// formDataUploadToS3Pvt
								bucket: s3bucket,
								key: key,
								storage: "INTELLIGENT_TIERING",
								cacheControl: "public, max-age=300",
								contentType: data.type,
								tagging: `dmSite=Gulfstream News&Project=News Release Manager&Name=${key}`,
								thumbnail: JSON.stringify({
									type: "img",
									filename: filename,
									store: {
										bucket: s3bucket,
										domain: assetDomain,
										keyPrefix: keyPrefix
									},
									options: {
										height: 650,
										width: 1000
									}
								})
							};
							for (let prop in params) {
								formData.append(prop, params[prop]);
							}
							formData.append("file", data);
							notify(`Uploading ${filename} ...`);
							const response = await binaryUpload(formData, submitBtn);
							if (response.success) {
								release.langs[editLang].images.push({
									name: filename.replace(/-/g, " ").replace(/\.(jpg|png)$/, ""),
									filename: filename,
									size: Math.round(files[i].size / 1000),
									src: "Upload",
									thumb: response.data ? response.data : placeholder,
									preview: `${assetHost}/${key}`,
									url: `${assetHost}/${key}`,
									created: new Date().getTime(),
									downloadable: true
								});
								notify(`Saved "${filename}" to database.`, "success");
							} else throw response.data;
						} catch (err) {
							console.error(err);
						}
						manageImages(release.langs[editLang].images);
					}
				}
			});
		// image upload button click handler

		$("select[name='lang']").val(editLang ? editLang : "en");
		// set language as en default or incoming lang

		$("[name='featured']").prop("checked", !editValues.featured ? false : true);
		$("[name='dotcom']").prop("checked", editValues.dotcom ? editValues.dotcom : false);
		$("[name='dotcom-sust']").prop("checked", editValues["dotcom-sust"] ? editValues["dotcom-sust"] : false);
		$("[name='status']").prop("checked", editValues.status ? editValues.status : false);
		$("[name='darkpage']").prop("checked", editValues.darkpage ? editValues.darkpage : false);
		if (editValues.images) {
			manageImages(editValues.images);
		}
		// some incoming data easier to insert here than inline above

		const editor = (el, height) => {
			el.parents(".field").removeClass("error");
			let editorId = el.attr("id");
			tinymce.init({
				//api: '2fnosgyoq814kc9vbaffo467cr3lagq7wib1aks2xio893ch',
				license_key: "gpl",
				selector: `textarea#${editorId}`,
				height: height,
				skin: false,
				paste_as_text: true,
				allow_script_urls: true,
				extended_valid_elements: "script[src|async]",
				content_css: `${location.pathname.indexOf("/dist/") > -1 ? `/dist/` : "/"}css/main.css`,
				plugins: "wordcount code autolink link lists",
				toolbar: "undo redo | bold italic underline strikethrough | formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | link | removeformat | code",
				menubar: "file edit view insert format tools",
				menu: {
					file: { title: "File", items: "newdocument restoredraft | preview | print " },
					edit: { title: "Edit", items: "undo redo | cut copy | selectall | searchreplace" },
					view: { title: "View", items: "code | visualaid visualchars visualblocks | spellchecker | preview fullscreen" },
					insert: { title: "Insert", items: "link" },
					format: { title: "Format", items: "bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontsizes align | removeformat" },
					tools: { title: "Tools", items: "spellchecker spellcheckerlanguage | code wordcount" },
					help: { title: "Help", items: "help" }
				}
			});
			// initialize text editors

			if (editorId === "newsBodyEditor") {
				let bodyEditor = tinymce.get(editorId);
				bodyEditor.on("blur", function () {
					let html = $(`<div>${bodyEditor.getContent()}</div>`);
					// jQuery requires the content to be wrapped in something
					// to use the .find() method later

					let summary = $("textarea[name='summary']");
					if (!summary.val()) {
						summary.parents(".field").removeClass("error");
						summary.val(html.length ? html.find("p").eq(0).text() : "");
					}
				});
			}
			// set blur listener on body editor so summary is populated
			// when focus leaves, if content has been entered
		};

		editor($("#newsBodyEditor"), 500);
		editor($("#footerEditor"), 300);
		//initiate TinyMCE editors for these elements

		let validatedFields = ["tags", "new_tags", "dateline", "created", "published_on", "pubtime", "headline", "summary", "newsBody", "footer"];
		validatedFields.forEach(field => {
			$(`[name='${field}']`).on("blur", function () {
				$(this).parents(".field").removeClass("error");
			});
		});
		$("[data-button='submit news form']").on("click", function (e) {
			e.preventDefault();
			processNewsRelease(validatedFields, news, tags, id, author, userLevel, updateRouter, release, buildNewsEditor);
			// processNewsRelease(validatedFields, news, tags, id, author, userLevel, imageArr, updateRouter, release, buildNewsEditor);
		});
		// submit form click handler

		if (id) {
			$("[data-button='delete news release']").on("click", async function (e) {
				const btn = $(this).css({ position: "relative" });
				e.preventDefault();
				try {
					await UIkit.modal.confirm(`<div class="uk-modal-heading">Just checking ...</div>
                <div class="uk-modal-body">
                    You are about to delete "${editValues.headline}" for ALL languages. If you wish to only to remove it for a particular language, toggle its "Status" off in its admin panel, or switch to that language in this release editor and change its status to "inactive". Otherwise, confirm the deletion:
                </div>`);
					notify(`Deleting release "${editValues.headline}" <span uk-spinner></span>`, "primary", "top-right", 3000, "release delete", true);
					try {
						const response = await request(
							{
								reqId: "f7ace6c3-dc2b-47f4-9f08-b890a61739ea",
								id: id,
								datatype: "release"
							},
							btn
						);
						notify("News release successfully saved", "success");
						notify("Removing release record from search table");
						try {
							await request(
								{
									reqId: "fb2a7910-c548-4457-b53b-2cad536bb3b3",
									id: id
								},
								btn
							);
						} catch (err) {
							console.error("Error updating search table:", err);
						}
						try {
							await updateCache(cachingServiceKeys);
						} catch (err) {
							console.error("Cache update error in release delete:", err);
						}
						notify(`Release "${editValues.headline}" successfully deleted`, "success");
						$("#list_wrapper").find(`[data-id='${id}']`).remove();
						news = news.filter(item => item.id != id);
						// update DOM and in-memory news array with a removal;
						// no need to to make another http request

						$(".dimmer").remove();
						newsButton.trigger("click");
						scroll($("#admin_controls"));
					} catch (err) {
						console.error(err);
						notify("There was an error", "danger", "top-right", 3000, "release delete", true);
					}
				} catch (err) {
					// no op for canceling confirmation
				}
			});
		}
		// delete release click handler (only if id exists)
	}
	// end buildNewsEditor function
};
// end buildReleaseEditor function

// const processNewsRelease = (validatedFields, news, tags, id, author, userLevel, imageArr, updateRouter, release, buildNewsEditor) => {
const processNewsRelease = async (validatedFields, news, tags, id, author, userLevel, updateRouter, release, buildNewsEditor) => {
	const newsEditor = $("#news_editor");
	let newsMsgsBottom = newsEditor.find("#form_messaging_bottom");
	let form = $("#news_form");
	["newsBodyEditor", "footerEditor"].forEach(editor => {
		tinymce.get(editor).save();
	});
	// move any modified editor contents into textarea inputs

	$("[data-button='approve name change']").trigger("click");
	// close any image name change inputs

	let values = {
		created: parseInt($("[name='createdReadable']").attr("data-timestamp")),
		updated: new Date().getTime(),
		tags: []
	};
	// starter values object

	let formLang = form.find("[name='lang']").val();
	let formStatus = form.find("[name='status']").prop("checked");
	let invalids = {
		en: [],
		cn: [],
		es: [],
		pt: [],
		ru: []
	};
	form.find(".error").each(function () {
		$(this).removeClass("error");
	});
	newsMsgsBottom.hide();
	validatedFields.forEach(name => {
		let field = form.find(`[name='${name}']`);
		switch (name) {
			case "dateline":
			case "pubTime":
			case "headline":
			case "subhead":
			case "summary":
			case "newsBody":
			case "footer":
				if (formStatus && !field.val()) {
					invalids[formLang].push(name);
				}
				for (let key in invalids) {
					if (key != formLang) {
						if (release.langs[key] && release.langs[key].status && (release.langs[key][name] === "undefined" || !release.langs[key][name])) {
							invalids[key].push(name);
						}
					}
				}
				break;
			// for most fields, they just should not be empty
			default:
				break;
		}
	});

	if (
		(function () {
			let invalid = false;
			for (let key in invalids) {
				if (invalids[key].length) {
					invalid = true;
				}
			}
			return invalid;
		})()
	) {
		// any invalids (per lang, status===true &&
		// validated field missing value )?

		newsMsgsBottom.html("").show();
		for (let key in invalids) {
			if (invalids[key].length) {
				newsMsgsBottom.append(`${!newsMsgsBottom.find("#intro").length ? `<span id="intro">Please address the following issues:<br/></span>` : ""}<br/><span class="underline">${languages[key]}-language release:</span><br/>`);
				invalids[key].forEach(invalidated => {
					let field = form.find(`[name='${invalidated}']`);
					field.parents(".field").addClass("error");
					newsMsgsBottom.append(`- "${field.siblings("label").text()}" must have a value<br/>`).addClass("error");
				});
			}
		}
	} else {
		// no validation errors; let's get processing that form

		newsMsgsBottom.hide();
		form.find("[name]").each(function () {
			let name = $(this).attr("name");
			switch (name) {
				case "status":
				case "featured":
				case "dotcom":
				case "dotcom-sust":
				case "darkpage":
					values[name] = $(this).prop("checked");
					break;
				case "embedContainer":
				case "dam_video":
				case "embed_download_link":
					// no-op: we want to explicitly
					// ignore these helper inputs
					break;
				default:
					values[name] = $(this).val() === "true" ? true : $(this).val() === "false" ? false : $(this).val() === "" ? null : $(this).val();
				// everything else: add its value, converting
				// string Booleans to true Booleans
				// and empty strings to nulls
			}
			// end switch statement
		});
		let domImages = $("#image_manager .image_card");
		if (domImages.length) {
			values.images = [];
			domImages.each(async function () {
				let srcImage = release.langs[values.lang].images.find(item => item.filename === $(this).find(".filename").text());
				if (srcImage) {
					values.images.push(srcImage);
				}
			});
		} else {
			values.images = [];
		}

		release.langs[values.lang].images = values.images;
		// pull out image URLs from DOM and add to values{}

		values.pubTime = parseInt(values.pubTime) * 1000;
		// flatPickr outputs date as Epoch in seconds,
		// so need to convert to milliseconds

		values.pubTime_translated = humanDate(values.pubTime, false, null, null, values.lang);
		// aid for apps ingesting feed without ability to
		// translate dates

		let msgTime = humanDate(values.pubTime, true, " at ");
		let previewBody = values.pubTime <= new Date().getTime() ? `The <span class="bold">${languages[values.lang]}</span>-language version of this release's publish date (<span class="bold">${msgTime}</span>) is current or past so it will publish <span class="bold">immediately</span>.` : `The <span class="bold">${languages[values.lang]}</span>-language version of this release's publish date (<span class="bold">${msgTime}</span>) is in the future, so it will <span class="bold">not</span> publish until then.`;
		previewBody = `${previewBody} Its status is <span class="bold">${values.status ? "Active" : "Inactive"}</span>.`;
		// first, build confirmation for current form

		for (let lang in release.langs) {
			if (lang != values.lang) {
				msgTime = humanDate(release.langs[lang].pubTime, true, " at ");
				previewBody = `${previewBody}<hr/>${release.langs[lang].pubTime <= new Date().getTime() ? `The <span class="bold">${languages[release.langs[lang].lang]}</span>-language version of this release's publish date (<span class="bold">${msgTime}</span>) is current or past so it will publish <span class="bold">immediately</span>.` : `The <span class="bold">${languages[release.langs[lang].lang]}</span>-language version of this release's publish date (<span class="bold">${msgTime}</span>) is in the future, so it will <span class="bold">not</span> publish until then.`} Its status is <span class="bold">${release.langs[lang].status ? "Active" : "Inactive"}</span>.`;
			}
		}

		await UIkit.modal.confirm(`<div class="uk-modal-heading">Just checking ...</div>
            <div class="uk-modal-body">
                ${previewBody}
            </div>`);

		values.updatedBy = author;
		// this always gets updated by current logged in
		// admin user

		let data = {};
		if (id) {
			data = news.find(item => item.id === id);
			values.createdBy = data.langs[values.lang].createdBy;
			// pass back the existing createdBy value
		} else {
			// this was a newly created release

			values.createdBy = author;
			// document whose login was active at
			// the creation of this version of this release

			data.id = uuid();
			data.type = "release";
			// type is the primary key for this table
		}
		// edited data is assigned to the appropriate <lang> key;

		release.langs[values.lang] = values;
		// release now has the latest values
		// from the validated form for this language

		data = Object.assign(data, release);
		// combine initial DB values with the new
		// values from form interactions
		// new data is set to current <lang> property

		data.langs[values.lang].id = data.id;

		const params = id
			? {
					// this is an edit, so we're upserting values via Requestor batchWrite
					reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
					data: [
						{
							PutRequest: {
								Item: data
							}
						}
					]
			  }
			: {
					// new releases get PUT instead
					reqId: "9e3c8e67-4671-4f56-87c3-abf8c07a7772",
					data: data
			  };

		notify(`Saving news release to database ...`);
		try {
			const form = $("#news_form");
			await request(params, $("#news_form"));
			notify("News release successfully saved", "success");
			// notify("Settling database ...", "info", "top-right", 7000);
			// $("#body").append(dimmer());
			// await timer(7000);
			$("#body").find(".dimmer").remove();
			try {
				await updateSearchTable(data, values.lang, form);
			} catch (err) {
				console.error("Error updating search table:", err);
			}
			try {
				await updateCache(cachingServiceKeys);
				notify("News release database reindexed", "success", "top-right", 3000, null, true);
				let thisLangTags = tags[values.lang] && tags[values.lang].length ? uniqueList(tags[values.lang].concat(values.tags)) : uniqueList(values.tags);
				// unique list of tags.en + values.tags

				if (!tags[values.lang] || !tags[values.lang].length || (tags[values.lang] && tags[values.lang].length != thisLangTags.length)) {
					// some tags from this news release are new, so tagList needs updating

					notify("Adding new tags to database ...");
					tags[values.lang] = uniqueList(thisLangTags).sort();
					// tags should now have any
					// new tags from frontend

					try {
						await request(
							{
								reqId: "0a781917-4959-4da0-901e-c555078aad80",
								datatype: "tagList",
								id: "tagList",
								names: {
									"#tags": "tags"
								},
								values: {
									":tags": tags
								},
								update: "set #tags = :tags"
							},
							$("#news_form")
						);
						notify("Successfully updated tags", "success");
					} catch (err) {
						console.error("Error updating tags:", err);
						throw err;
					}
				}
				notify("Refreshing news");
				try {
					const response = await fetchNews(
						{
							container: $("#news_form"),
							size: 1
						},
						[],
						urlId,
						{
							reqId: "c6148d32-343e-4918-b0fb-53982f7412e0",
							datatype: "release",
							filter: "#langs.#lang.#index BETWEEN :start AND :end",
							namesAdd: {
								"#langs": "langs",
								"#lang": lang,
								"#index": "index"
							},
							valuesAdd: {
								":start": 0,
								":end": 9
							}
						},
						userLevel
					);
					newsEditor.remove();
					updateRouter(response, userLevel);
					scroll($("#admin_controls"));
				} catch (err) {
					console.error(err);
					notify(err, "danger");
				}
			} catch (err) {
				console.error(err);
				notify(err, "danger");
			}
		} catch (err) {
			console.error(err);
			notify("There was an error saving your form.", "danger");
		}
	}
	// form passed validation
};
// end processNewsRelease function
